import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { ApiError, getMe } from '../lib/api-client';
import { useI18n } from '../lib/i18n-context';

/**
 * 帳號資訊頁 — `/me/account`（F，唯讀）。
 *
 * `GET /auth/me`；顯示名稱 / Email / user_id / 權限數 / 2FA 狀態。
 * 後端目前無帳號編輯 endpoint → 本頁唯讀，提示洽客服。
 */
export function AccountPage(): JSX.Element {
  const { t } = useI18n();
  const query = useQuery({ queryKey: ['auth', 'me'], queryFn: getMe, retry: false });

  return (
    <div className="app-shell">
      <header className="topbar">
        <h1>{t('account.title')}</h1>
        <Link to="/" className="topbar-back">
          {t('common.backHome')}
        </Link>
      </header>

      {query.isPending && <p>{t('common.loading')}</p>}
      {query.isError && (
        <p className="error-text">
          {t('account.loadFailed')}
          {query.error instanceof ApiError
            ? ` ${query.error.problem?.detail ?? query.error.message}`
            : ''}
        </p>
      )}
      {query.isSuccess && (
        <article className="card">
          <AccountField label={t('account.displayName')} value={query.data.display_name ?? '—'} />
          <AccountField label={t('account.email')} value={query.data.email} />
          <AccountField label={t('account.userId')} value={query.data.user_id} mono />
          <AccountField
            label={t('account.permissions')}
            value={t('account.permissionsCount', { count: query.data.permissions.length })}
          />
          <AccountField
            label={t('account.twoFactor')}
            value={query.data.requires_2fa ? t('account.twoFactorOn') : t('account.twoFactorOff')}
          />
          <p style={{ fontSize: 12, color: '#777', marginTop: 12 }}>{t('account.readonlyNote')}</p>
        </article>
      )}
    </div>
  );
}

function AccountField({
  label,
  value,
  mono,
}: {
  label: string;
  value: string;
  mono?: boolean;
}): JSX.Element {
  return (
    <p style={{ margin: '0 0 10px' }}>
      <span style={{ color: '#777', fontSize: 13 }}>{label}</span>
      <br />
      <span style={{ fontFamily: mono === true ? 'monospace' : undefined, fontSize: 14 }}>
        {value}
      </span>
    </p>
  );
}
